const addressofContract = '0x59c6d3996F739c7960fD59c8eEaaD55aF8614Db3'
export default addressofContract;